<!--edit contacts modal -->

<div mat-dialog-content style="max-height: 85vh !important;">
    <div style="padding:20px;">
        <h3 style="text-align: left !important; color: #424242">Thermal Enclosure Checklist</h3>
        <small style="text-align: left;
        color: #424242;
        font-size: 18px;">{{data.street_address}}</small>
    </div>



    <div>
        <div class="notes-container" style="padding:20px;">
            <div class  = "alert alert-warning" style="color: #424242;
            background-color: #eeeeee;
            border-color: #ebebeb;
            width: 100%;
            margin-right: 10px;" *ngIf="check.predrywallnotes4builder != ''">
            <div><h4  style="font-size: 16px; text-align: left;">Pre-drywall Inspection Notes:</h4></div>
            <div><p style="text-align: left; word-break: break-word;">{{check.predrywallnotes4builder}}</p></div>
            </div>

            <div class  = "alert alert-warning" style=" color: #424242;
            background-color: #eeeeee;
            border-color: #ebebeb;
            width: 100%;
            margin-right: 10px;" *ngIf="check.finalnotes4builder != ''">
            <div><h4 style="text-align: left;font-size: 16px;">Final Inspection Notes:</h4></div>
            <div><p style="text-align: left; word-break: break-word;">{{check.finalnotes4builder}}</p></div>
            </div>
        </div>




        <div   *ngIf = "!allComplete() || engineerLetterReqd">




        <div style="padding:20px;"> <h4 *ngIf="!allComplete()"  style="text-align: left; color:#424242" >Click 'Verify' on each item below to complete verification. </h4></div>


        <div id="eletter_div"  class="el-div" *ngIf = "engineerLetterReqd && !engineerLetterError" style="text-align-last:left; padding: 20px;">

            <p class="el-warning-text" style="font-size: 18px;
            font-weight: 600;"><i style="font-size: 24px;margin: 10px;color: #424242;" class="fas fa-exclamation-triangle"></i>An engineer letter is required for verifying one or more items. Please upload below: </p>
            <input style="padding: 3%;
            border: 1px solid #d0d0d0;
            width: 95%;"
             type="file" (change)="uploadFileToDrive($event)" />

             <!-- <div style="padding-top: 10px;" ><p>Alternatively, you can choose to email it directly to <span style="font-weight:bold;">engineerletters@theperformancepoint.com</span> with subject: <span style="font-weight:bold;">Engineer Letter - [Subdivision]-[Lot]</span> </p><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 220px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="overrideEL()"><i style="font-size: 0.75em;margin-right: 5px;font-size:20px;" class="fas fa-check"></i>I will email it directly</button></div> -->

        </div>

        <div id="eletter_div" *ngIf = "engineerLetterReqd && engineerLetterError">
            <div><p style="padding-left:20px; padding-top:20px;">There was an error uploading your engineer letter (most likely due to your antivirus software). Please email <span style="font-weight: bold;">engineerletters@theperformancepoint.com</span> directly with your engineer letter. You may continue verifying items (if applicable) 
             </p>
            </div>
             <div>
                <button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 220px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="overrideEL()"><i style="font-size: 0.75em;margin-right: 5px;font-size:20px;" class="fas fa-check"></i>I will email it directly</button>
             </div>
        </div>



        <div *ngIf = "check.fenlevels == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding-left:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('fenlevels')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>1.1 Fenestration meets or exceeds levels specified in Item 2.1 of the Rater Design Review Checklist</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.fenlevels}}</p></div>



      <div *ngIf = "check.insmeets == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('insmeets')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>1.2 Insulation meets or exceeds levels specified in Item 3.1 of the Rater Design Review Checklist</label>

        
          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.insmeets}}</p>
        
        </div>



      <div *ngIf = "check.insachieve == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('insachieve')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>1.3 All insulation achieves RESNET -defined Grade I installation.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.insachieve}}</p></div>





      <div *ngIf = "check.dropped_ceiling_soffit == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('dropped_ceiling_soffit')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.1 Dropped ceilings / soffits below unconditioned attics, and all other ceilings</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.dropped_ceiling_soffit}}</p></div>



      <div *ngIf = "check.wall_b_shower_tub == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('wall_b_shower_tub')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.2 Walls behind showers, tubs, staircases, and fireplaces</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.wall_b_shower_tub}}</p></div>



      <div *ngIf = "check.attic_knee_walls == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('attic_knee_walls')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.3 Attic knee walls and skylight shaft walls.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.attic_knee_walls}}</p></div>



      <div *ngIf = "check.wall_a_porch_roof == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('wall_a_porch_roof')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.4 Walls adjoining porch roofs or garages.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.wall_a_porch_roof}}</p></div>



      <div *ngIf = "check.double_walls == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('double_walls')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.5 Double-walls and all other exterior walls.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.double_walls}}</p></div>



      <div *ngIf = "check.flr_o_unconbsmt_crawl == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('flr_o_unconbsmt_crawl')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.6 Floors above garages, floors above unconditioned basements or crawlspaces, and cantilevered floors.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.flr_o_unconbsmt_crawl}}</p></div>



      <div *ngIf = "check.cantilevered_floor == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('cantilevered_floor')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>2.7 All other floors adjoining unconditioned space (e.g., rim / band joists at exterior wall or at porch roof).</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.cantilevered_floor}}</p></div>




      <div *ngIf = "check.r21_o_wall == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('r21_o_wall')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.1 For insulated ceilings with attic space above (i.e., non-cathedralized), Grade I insulation extends to the
      inside face of the exterior wall below and is ≥ R-21 in CZ 1-5; ≥ R-30 in CZ 6-8</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.r21_o_wall}}</p></div>



      <div *ngIf = "check.slab_edge_insulation == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('slab_edge_insulation')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.2 For slabs on grade in CZ 4-8, 100% of slab edge insulated to ≥ R-5 at the depth specified by the 2009
      IECC and aligned with the thermal boundary of the walls 1</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.slab_edge_insulation}}</p></div>



      <div *ngIf = "check.r21_attic_platform == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('r21_attic_platform')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.3 Insulation beneath attic platforms (e.g., HVAC platforms, walkways) ≥ R-21 in CZ 1-5; ≥ R-30 in CZ 6-8</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.r21_attic_platform}}</p></div>



      <div *ngIf = "check.ins_sheathing == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('ins_sheathing')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.1 Continuous rigid insulation, insulated siding, or combination of the two is:≥ R-3 in CZ 1-4; ≥ R-5 in CZ 5-</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.ins_sheathing}}</p></div>



      <div *ngIf = "check.sip == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('sip')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.2 Structural Insulated Panels OR; Insulated Concrete Forms OR; Double-wall framing OR;</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.sip}}</p></div>



      <div *ngIf = "check.r6_corner == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('r6_corner')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.3a Corners insulated ≥ R-6 to edge.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.r6_corner}} </p>
        
        </div>



      <div *ngIf = "check.ins_headr == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('ins_headr')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.3b Headers above windows & doors insulated ≥ R-3 for 2x4 framing or equivalent cavity width,
      and ≥ R-5 for all other assemblies (e.g., with 2x6 framing).</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.ins_headr}}</p>
    
    </div>



      <div *ngIf = "check.min_wind_dr_framing == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('min_wind_dr_framing')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.3c Framing limited at all windows & doors to one pair of king studs, plus one pair of jack studs
      per window opening to support the header and sill,.</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.min_wind_dr_framing}}</p>
    
    </div>



      <div *ngIf = "check.ins_wall_intersect == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('ins_wall_intersect')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.3d Interior / exterior wall intersections insulated to same R-value as rest of exterior wall.</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.ins_wall_intersect}}</p>
          
        </div>




      <div *ngIf = "check.min_stud_spacing == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('min_stud_spacing')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>3.4.3e Minimum stud spacing of 16 in. o.c. for 2x4 framing in all Climate Zones and,
      in CZ 6-8, 24 in. o.c. for 2x6 framing.</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.min_stud_spacing}}</p>

    </div>




      <div *ngIf = "check.duct_flue_shaft == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('duct_flue_shaft')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.1 Ducts, flues, shafts, plumbing, piping, wiring, exhaust fans, & other penetrations to unconditioned
      space sealed, with blocking / flashing as needed</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.duct_flue_shaft}}</p></div>



      <div *ngIf = "check.recessed_light == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('recessed_light')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.2 Recessed lighting fixtures adjacent to unconditioned space ICAT labeled and gasketed. Also, if in
      insulated ceiling without attic above, exterior surface of fixture insulated to ≥ R-10 in CZ 4-8.</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.recessed_light}}</p></div>



      <div *ngIf = "check.sealedsillplate == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('sealedsillplate')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.3 Above-grade sill plates adjacent to conditioned space sealed to foundation or sub-floor. Gasket also
      placed beneath above-grade sill plate if resting atop concrete / masonry & adjacent to cond. space.</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.sealedsillplate}}</p></div>



      <div *ngIf = "check.topplatespresent == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('topplatespresent')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.4 Continuous top plate or blocking is at top of walls adjoining unconditioned space, and sealed</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.topplatespresent}}</p></div>



      <div *ngIf = "check.sealedtopplate == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('sealedtopplate')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.5 Drywall sealed to top plate at all unconditioned attic / wall interfaces using caulk, foam, drywall
      adhesive (but not other construction adhesives), or equivalent material. Either apply sealant directly
      between drywall and top plate or to the seam between the two from the attic above</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.sealedtopplate}}</p></div>



      <div *ngIf = "check.sealedwindows == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('sealedwindows')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.6 Rough opening around windows & exterior doors sealed</label>

          
          <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.sealedwindows}}</p></div>



      <div *ngIf = "check.sealedmarriagejointsmodhomes == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('sealedmarriagejointsmodhomes')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.7 Walls that separate attached garages from occupiable space sealed and, also, an air barrier installed
      and sealed at floor cavities aligned with these walls</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.sealedmarriagejointsmodhomes}}</p></div>



      <div *ngIf = "check.sealed_common_wall == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('sealed_common_wall')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.8 In multifamily buildings, the gap between the common wall (e.g. the drywall shaft wall) and the
      structural framing between units sealed at all exterior boundaries</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.sealed_common_wall}}</p></div>



      <div *ngIf = "check.door_to_uncon == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('door_to_uncon')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.9 Floors adjacent to unconditioned space (e.g., attics, garages, basements) or ambient conditions made
      substantially air-tight with weatherstripping or equivalent gasket</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.door_to_uncon}}</p></div>




      <div *ngIf = "check.attic_dropdown == 'Must Correct'" class="mustCorrectItem"><label><button style=' padding:20px; background: #8bc34a;border: 0px;color: #424242;width: 100px;padding: 3px;margin: 10px;border-radius: 10px;' (click)="checkValues('attic_dropdown')"><i style="font-size: 0.75em;margin-right: 5px;" class="fas fa-check"></i>Verify</button>4.10 Attic access panels, drop-down stairs, & whole-house fans equipped with durable ≥ R-10 cover that is
      gasketed (i.e., not caulked). Fan covers either installed on house side or mechanically operated.</label>

      
      <p style= "color: #6d6d6d;padding: 10px;font-size: 16px;" > {{checknotes.attic_dropdown}}</p></div>


                <!--<div>
                    <button mat-button color="blue" ng-click="checkValues()" [mat-dialog-close]="3">Submit</button>
                </div> -->

        </div>



            <div *ngIf = "allComplete() && !engineerLetterReqd" style="margin: 0 auto;">


                <h4 style="text-align: center;color:#3d3d3d">Your checklist is complete!</h4>
                <h5 style="text-align: center;color:#3d3d3d; font-weight: 400;">Type your initials below, then click submit.</h5>
                <div *ngIf="allComplete() && !engineerLetterReqd" style="margin: 0 auto; padding:5%;">

                    <div style="text-align-last: center; margin: 0 auto;  padding: 2%;display: flex;
                    flex-direction: column;
                    align-items: center;">

                              <input style="font-size: 24px;
                                width: 3em;" matInput placeholder = "Type intials here" [(ngModel)] = "builderinitials">
                    </div>



                        <div style="    display: flex;
                        margin: 0 auto;
                        padding: 2%;
                        justify-content: center;">
                            <button style="width: 120px;height: 50px;font-size: 18px;" mat-raised-button *ngIf = "builderinitials.length > 1 && builderinitials.length < 4" color="green" (click)="save(check.id)" [mat-dialog-close]="4">Submit</button>
                        </div>

                </div>
            </div>


        <!--
        <form name = "addContact" sf-schema="schema" sf-form="form" sf-model="entity"  ng-submit="post(addContact)">
        </form>
        -->


    </div>

    <div class= "modal-footer">
        <button style="color: #424242;
        background-color: #eeeeee;
        border-color: #bbbbbb;
        width: 120px;
        height: 50px;
        border-width: 1px;
        border-radius: 10px;" ng-click="$close()" [mat-dialog-close]="3">Cancel</button>
    </div>

</div>
